import DigitalBundlesMissingConfigurationModal, {
  DIGITAL_BUNDLES_MISSING_CONFIGURATION_MODAL,
} from './modal';

export { DIGITAL_BUNDLES_MISSING_CONFIGURATION_MODAL };

export default DigitalBundlesMissingConfigurationModal;
